const isNotEmpty = value => {
    const isValid = value && value.length > 0
    if (!isValid) {
        return {isValid, message: "Please enter [label]."}
    }
    return {isValid, message: ""}
}

export default isNotEmpty